import React from 'react';
import { BaasicSelect } from 'core/components';
import { observer } from 'mobx-react';

function BaasicFieldSelectTemplate({ field, loading = false, ...other }) {
	return (
		<BaasicSelect
			{...other}
			isLoading={loading}
			onChange={field.sync}
			placeholder={field.placeholder}
			options={field.extra}
			value={field.value}
			field={field}
		/>
	);
}

export default observer(BaasicFieldSelectTemplate);
